import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ReturnDashboardItemsPayload } from "src/app/models/dashboard/return-dashboard-items-payload";
import { DashboardService } from "src/app/services/dashboard/dashboard.service";

@Injectable()
export class UserDashboardItemsResolver implements Resolve<Observable<ReturnDashboardItemsPayload>> {

    constructor(private dashboardService: DashboardService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Observable<ReturnDashboardItemsPayload>> {
        const response = this.dashboardService.getUserDashboardItems()
            .pipe(map(response => {
                if (response.success) {
                    return response.payload;
                }
                else {
                    return <ReturnDashboardItemsPayload>{
                        dashboardItems: []
                    };
                }
            }));
        const responsePromise = new Promise<Observable<ReturnDashboardItemsPayload>>((resolve, reject) => { resolve(response) });
        return responsePromise;
    }

}